import { Select, SelectItem, SelectSkeleton } from "@carbon/react";
import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";

const GET_GROUP_BY_ID = gql`
    query SchoolGroupById($id: String!) {
        schoolGroupById(id: $id) {
            __typename
            ... on SchoolClass {
                students {
                    id
                    username
                    surname
                    lastname
                }
            }
            ... on Group {
                students {
                    id
                    username
                    surname
                    lastname
                }
            }
        }
    }


`;

export default function StudentSelector({ classId = null, groupId = null, selectedStudent = null, onStudentChange, label = true }) {
    const id = classId || groupId;

    const { loading, error, data } = useQuery(GET_GROUP_BY_ID, {
        variables: { id },
        skip: !id,
        fetchPolicy: "cache-and-network",
        errorPolicy: "all",
    });

    useEffect(() => {
        const students = data?.schoolGroupById?.students || [];
        if (!loading && students.length > 0 && !selectedStudent) {
            // Auto-select first student if no selectedStudent is provided
            onStudentChange && onStudentChange(students[0].id);
        }
    }, [loading, data, selectedStudent, onStudentChange]);

    if (!id) return null;
    if (loading) return <SelectSkeleton />;
    if (error) return <p>Error loading students: {error.message}</p>;

    const students = data?.schoolGroupById?.students || [];

    const handleOnChange = (event) => {
        if (onStudentChange) {
            onStudentChange(event.target.value);
        }
    };

    return (
        <div className="w-full md:w-1/2">
            {label && <label className="block mb-2 text-sm font-medium text-gray-700">
                Schüler auswählen
            </label>}
            <div className="flex items-center w-full">
                <Select
                    id={`select-student`}
                    className="w-full"
                    onChange={handleOnChange}
                    value={selectedStudent || (students.length > 0 ? students[0].id : "")}
                    hideLabel
                >
                    {students.map((student) => (
                        <SelectItem
                            key={student.id}
                            value={student.id}
                            text={`${student.lastname ? student.lastname.toUpperCase() : ""} ${student.surname || ""} (${student.username || ""})`}
                        />
                    ))}
                </Select>
            </div>
        </div>
    );
}
